$('.frame-type-form_formframework input').on('change', function() {
    if ( $(this).val() === '') {
        $(this).attr('value', '');
        $(this).closest('.group').next('.error.help-block').css('display', 'block');
    } else {
        $(this).closest('.group').next('.error.help-block').css('display', 'none');
    }
});

$('.frame-type-form_formframework input[type="checkbox"]').on('change', function() {
    if ( $(this).prop('checked' ) ) {
        $(this).closest('.group').next('.error.help-block').css('display', 'none');
    } else {
        $(this).closest('.group').next('.error.help-block').css('display', 'block');
    }
});

$('.frame-type-form_formframework textarea').on('change', function() {
    if ( $(this).val() === '') {
        $(this).attr('value', '');
        $(this).next('.error.help-block').css('display', 'block');
    } else {
        $(this).next('.error.help-block').css('display', 'none');
    }
});